import {SelectHTMLAttributes} from "react";
import {cva, type VariantProps} from "class-variance-authority";
import {cn} from "../../lib/Utils";

const selectOptionProps = cva(
    "appearance-none border rounded-lg text-surface-400 placeholder:text-surface-400",
    {
        variants: {
            intent: {
                primary: "bg-surface-950 border-surface-700 ",
            },
            sizing : {
                small : "",
                medium : "w-1/2 py-2.5 px-4 text-sm",
                large : "w-full py-3 px-4 pr-10",
            },
            showEffects : {
                true : "transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-brand-700/50 focus:border-brand-500",
                false : "",
            },
        },
        defaultVariants: {
            intent: "primary",
            showEffects : true,
        },
    }
);

export interface SelectOptionProps
    extends SelectHTMLAttributes<HTMLSelectElement>,
        VariantProps<typeof selectOptionProps> {
}

const SelectOptions = ({className, intent, sizing, showEffects, ...props}: SelectOptionProps) => (
    <>
        <select
            className={cn(selectOptionProps({intent, sizing, showEffects}), className)}
            {...props}
        />
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3">
            <svg className="h-4 w-4 text-surface-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
                 stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5"/>
            </svg>
        </div>
    </>
)
;


SelectOptions.displayName = "SelectOptions"; // for debugging
export {SelectOptions};





